'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _widgetActions = require('../actions/widget-actions');

var _constats = require('./constats');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 Here we specify where to find the arguments to replace in the loaders int the request.
 **/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
    _practicesIds_: 'query.practicesIds',
    _link_: 'query.link',
    _responsiveId_: 'query.responsiveId',
    _customizations_: 'query.customizations'
};

var setupProfiles = function setupProfiles(practicesIds, baseUrl, link, responsiveId, customizations, xhrConfig) {
    return function (dispatch) {
        //fetching all customizations from one object from query

        try {
            practicesIds = JSON.parse(practicesIds);
        } catch (e) {
            console.error(e);
        }

        try {
            customizations = JSON.parse(customizations);
        } catch (e) {
            console.error(e);
        }

        var _customizations = customizations,
            tabs = _customizations.tabs,
            activeTab = _customizations.activeTab,
            bodyStyle = _customizations.bodyStyle,
            minReviewRating = _customizations.minReviewRating,
            showSpecialistImageInReview = _customizations.showSpecialistImageInReview,
            showPracticeImageInReview = _customizations.showPracticeImageInReview,
            showProfileLogo = _customizations.showProfileLogo,
            reviewItemBackground = _customizations.reviewItemBackground,
            reviewItemFrame = _customizations.reviewItemFrame,
            wrapperFrame = _customizations.wrapperFrame;


        tabs = tabs || _constats.tabsArray;

        activeTab = _constats.tabsArray.indexOf(activeTab) > -1 ? activeTab : tabs[0];

        showSpecialistImageInReview = showSpecialistImageInReview === 'true' || showSpecialistImageInReview === true;
        showPracticeImageInReview = showPracticeImageInReview === 'true' || showPracticeImageInReview === true;
        showProfileLogo = showProfileLogo === 'true' || showProfileLogo === true;
        reviewItemFrame = reviewItemFrame === 'true' || reviewItemFrame === true;

        wrapperFrame = wrapperFrame === false || wrapperFrame === 'false' ? false : wrapperFrame;
        minReviewRating = parseInt(minReviewRating);

        if (isNaN(minReviewRating)) {
            minReviewRating = 0;
        }

        return _promise2.default.all([dispatch(_widgetActions.widgetActions.getLayout({ link: link, responsiveId: responsiveId, tabs: tabs, bodyStyle: bodyStyle, showSpecialistImageInReview: showSpecialistImageInReview, showPracticeImageInReview: showPracticeImageInReview, showProfileLogo: showProfileLogo, reviewItemBackground: reviewItemBackground, reviewItemFrame: reviewItemFrame, wrapperFrame: wrapperFrame, minReviewRating: minReviewRating })), dispatch(_widgetActions.widgetActions.changeTab(activeTab))]).then(function () {
            return _promise2.default.all(practicesIds.map(function (id) {
                return _widgetActions.widgetActions.loadPractice(id, xhrConfig)(dispatch);
            }));
        }).then(function (practicesData) {
            var practicesUUIDs = practicesData.map(function (practiceResponse) {
                return practiceResponse.practice.id;
            });

            return (0, _constats.loaderFromQueryOptions)(practicesUUIDs, activeTab, _constats.DEFAULT_REVIEWS_LIMIT, _constats.DEFAULT_REVIEWS_OFFSET, minReviewRating, dispatch, xhrConfig);
        });
    };
};
var loaders = exports.loaders = [{
    key: 'practices',
    action: setupProfiles,
    arguments: ['_practicesIds_', typeof process !== 'undefined' && 'https://www.doctify.co.uk', '_link_', '_responsiveId_', '_customizations_'],
    dynamicArguments: ['_practicesIds_', '_link_', '_responsiveId_', '_customizations_']
}];